// extracted by mini-css-extract-plugin
export const intro = "about-module--intro--NcYBY";
export const span = "about-module--span--27f9o";
export const photo = "about-module--photo--3dv1d";
export const img = "about-module--img--14rGK";
export const icons = "about-module--icons--2VP-7";
export const icon = "about-module--icon--2JY7V";